import './index.scss'
import React, {useEffect, useRef, useState} from "react";
import {Header} from "../../../../components";
import Service from "../service";
import Library from "../../../../library";

const { JsBridge, Platform } = Library;
const isMiniprogram = Platform.check.isMiniprogram()

const MyCollectionPage = () => {
  const pageDom = useRef(null);
  const { clientId, openId, collList: collListParam } = Library.Util.url.paramsToObj();
  const [data, setData] = useState({});
  const [userInfo, setUserInfo] = useState({});

  // 从链接 collList 参数解析列表
  const collListFromUrl = React.useMemo(() => {
    if (!collListParam) return null;
    try {
      const parsed = JSON.parse(decodeURIComponent(collListParam));
      return Array.isArray(parsed) ? parsed : null;
    } catch {
      return null;
    }
  }, [collListParam]);

  useEffect(() => {
    if (!collListFromUrl) {
      getData();
    }
  }, [collListFromUrl]);

  const getData = async () => {
    try {
      const res = await Service.collList();
      if(res?.data){
        setData(res.data)
      }

      // const mockData = {
      //   list: [
      //     { imgUrl: 'https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/carbon1t.png', count: 4 },
      //     { imgUrl: 'https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/carbon1t.png', count: 4 },
      //     { imgUrl: 'https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/carbon1t.png', count: 4 },
      //     { imgUrl: 'https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/carbon1t.png', count: 4 },
      //     { imgUrl: 'https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/carbon1t.png', count: 4 },
      //     { imgUrl: 'https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/carbon1t.png', count: 4 },
      //     { imgUrl: 'https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/carbon1t.png', count: 4 },
      //     { imgUrl: 'https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/carbon1t.png', count: 4 },
      //     { imgUrl: 'https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/carbon1t.png', count: 4 },
      //     { imgUrl: 'https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/carbon1t.png', count: 4 },
      //   ],
      // };
      // setData(mockData);
    } catch (error) {
      console.log('获取数据失败:', error);
    }
  };

  // 优先使用链接 collList，否则用 data.list
  const collectionList = collListFromUrl ?? data?.list ?? [];

  return (
    <div className="MyCollectionPage" ref={pageDom}>
      <div>
        <Header midText="我的藏品" bgColor={'#FFFFFF'}/>
      </div>
      <div className="body-container">
        <div className="collection-grid">
          {collectionList.map((item, index) => (
            <div key={index} className="collection-item">
              <img src={item.imgUrl} alt="" />
              <div className="numTag">{item?.count || 0}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
export default MyCollectionPage